<template>
  <span :class="clazz">
    <button v-if="img === undefined" :class="button_clazz" @click="click">
      {{ tx(label) }}
    </button>
    <span class="img">
      <imgWidget
        v-if="img"
        :img="img"
        v-on:click="click()"
        data-toggle="tooltip"
        data-placement="top"
        :title="help"
      ></imgWidget>
    </span>
  </span>
</template>

<script>
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import imgWidget from "ireal-vue/widgets/ImgWidget.vue";

export default {
  name: "toogle-button-component",
  mixins: [inputComponentMixin],

  components: { imgWidget },
  async mounted() {},
  methods: {
    click() {
      this.value = !this.value;
      this.value ? this.doActionTrue() : this.doActionFalse();
    },
    doActionTrue(payload) {
      this[this.attributes["action-true"]](payload);
    },
    doActionFalse(payload) {
      this[this.attributes["action-false"]](payload);
    }
  },
  computed: {
    label() {
      return `${this.attributes.model}_${this.value ? "true" : "false"}`;
    },
    button_clazz() {
      return `btn btn-primary w-100 text-uppercase`;
    },
    img() {
      return this.value ? this.attributes.img_false : this.attributes.img;
    },
    help() {
      var model_help = `${this.attributes.model}_help`;
      return this.attributes.model !== undefined ? this.tx(model_help) : "";
    }
  }
};
</script>
<style scoped></style>
